/**
 * The publications screen's route, kept beside the `routes.ts` that registers
 * it so a caller elsewhere derives the URL from the same literal.
 *
 * Also owns the nested publication detail route's literal: the detail screen
 * sits under this one, so its path is derived here rather than the two
 * screens reaching into each other. `publication/paths.ts` re-exports both.
 *
 * Relative to the router's `basepath`, like every other route literal here.
 */

import { interpolatePath } from '@tanstack/react-router';

export const PUBLICATIONS_PATH = '/c/$campaignId/publications';

export function publicationsPath(campaignId: string): string {
  return interpolatePath({ path: PUBLICATIONS_PATH, params: { campaignId } }).interpolatedPath;
}

export const PUBLICATION_PATH = `${PUBLICATIONS_PATH}/$postId`;

/** The Publicação entry's own page with no post chosen yet: its picker. A
 *  static segment, so it outranks `$postId` for this one literal. */
export const PUBLICATION_SELECT_PATH = `${PUBLICATIONS_PATH}/publicacao`;

export function publicationPath(campaignId: string, postId: string): string {
  return interpolatePath({ path: PUBLICATION_PATH, params: { campaignId, postId } })
    .interpolatedPath;
}
